import React from 'react'
import './CTA.css'

const CTA = () => {
  return (
    <div>CTA</div>
  )
}

export default CTA